import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from './messages'

Vue.use(VueI18n)

export const LOCALES = {
  ZH_CN: 'zh-CN',
  EN_US: 'en-US',
}

export const LOCALE_STORAGE_KEY = 'glacix-locale'

export function resolveInitialLocale() {
  if (typeof window === 'undefined') return LOCALES.ZH_CN

  const savedLocale = window.localStorage.getItem(LOCALE_STORAGE_KEY)
  if (savedLocale && messages[savedLocale]) {
    return savedLocale
  }

  const browserLocale = (window.navigator.language || '').toLowerCase()
  if (browserLocale.startsWith('en')) {
    return LOCALES.EN_US
  }

  return LOCALES.ZH_CN
}

export function persistLocale(locale) {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(LOCALE_STORAGE_KEY, locale)
  }
}

export function applyDocumentLocale(locale) {
  if (typeof document === 'undefined') return

  document.documentElement.lang = locale
  document.documentElement.setAttribute('data-locale', locale)
}

const i18n = new VueI18n({
  locale: resolveInitialLocale(),
  fallbackLocale: LOCALES.ZH_CN,
  messages,
})

applyDocumentLocale(i18n.locale)

export default i18n
